<script>
    // https://svelte.dev/docs#createEventDispatcher
    import { createEventDispatcher } from "svelte";
    const dispatch = createEventDispatcher();

    import UTILS from "./classes/utilities.js";

    import ProductOrder from "./ProductOrder.svelte";
    import Product from "./Product.svelte";

    export let productOrders;
    export let supplements = [];

    function needsUpdate() {
        productOrders = productOrders;
    }

    function productOrderChanged(productOrder) {
        console.log(
            "ProductOrders.productOrdersChanged",
            productOrders,
            productOrder
        );
        productOrders.cleanup();
        needsUpdate();
    }

    function incrementProductOrders() {
        productOrders.increment();
        console.log("ProductOrders.incrementProductOrders", productOrders);
        needsUpdate();
    }

    function decrementProductOrders() {
        productOrders[0].decrement();
        console.log("ProductOrders.decrementProductOrders", productOrders);
        needsUpdate();
    }
</script>

<div class="product-orders">
    <Product product={productOrders[0].product}>
        {#if !productOrders.hasSupplements()}
            <button
                on:click={() => decrementProductOrders()}
                class="calculator minus"></button
            >
            <span class="quantity">{productOrders[0].quantity}</span>
        {/if}
        <button
            on:click={() => incrementProductOrders()}
            class="calculator plus"></button
        >
        <span class="price">{UTILS.formatMoney(productOrders.getPrice())}</span>
    </Product>
    {#if productOrders.isBillable() && productOrders.hasSupplements()}
        <span class="price">{UTILS.formatMoney(productOrders.getPrice())}</span>
        {#each productOrders as productOrder}
            <ProductOrder
                {productOrder}
                {supplements}
                on:productOrderChanged={(ev) =>
                    productOrderChanged(ev.detail)}
            />
        {/each}
    {/if}
</div>
